import { Button, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import ModalV2 from '/@/components/bayer/modal-v2';
import { useMutateCreateCropMonitoringNote } from '/@/hooks/crop-monitoring-notes';
import { _ } from '/@/locale';
import type { CropMonitoring } from '/@/types/crop-monitoring';
import type { RegistryAddStep } from './types';

const CreateRegistryNote = ({
    open,
    onClose,
    onSuccess,
    setStep,
    fieldId,
    cropMonitoring,
}: {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    setStep: (step: RegistryAddStep) => void;
    fieldId?: number;
    cropMonitoring?: CropMonitoring;
}) => {
    const createNote = useMutateCreateCropMonitoringNote();
    const [content, setContent] = useState('');

    const handleCreateNote = async () => {
        if (!content.trim() || !fieldId) return;
        await createNote.trigger({
            content: content.trim(),
            field: fieldId,
            plantingDateCropMonitoring: cropMonitoring?.id,
        });
        onSuccess();
    };

    return (
        <ModalV2
            open={open}
            onClose={onClose}
            goBack={() => setStep('select')}
            title={_('Registrar una nota')}
            bodyProps={{ alignItems: 'stretch', textAlign: 'left', spacing: 2 }}
            actionsProps={{ justifyContent: 'flex-end' }}
            actions={
                <Button
                    variant='contained'
                    color='secondary'
                    disabled={!content.trim() || !fieldId || createNote.isMutating}
                    onClick={handleCreateNote}
                >
                    {_('Registrar en el seguimiento')}
                </Button>
            }
        >
            <Stack>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {_('Nota')}
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder={_('Escribir una observación')}
                    value={content}
                    onChange={(event) => setContent(event.target.value)}
                />
            </Stack>
        </ModalV2>
    );
};

export default CreateRegistryNote;
